<template>
	<div class="column is-3 sidenav">
		<aside id ="sideMenu"  class="menu is-hidden-mobile" :class="{'is-active': menuOpen}">
			<div class="side-menu-title">
				Psychic Manager Menu
			</div> 
			<ul class="menu-list">
				<li><router-link to="/dashboard" @click.native="$emit('toggle-menu')">Dashboard</router-link></li>
				<li><router-link to="/psychics" @click.native="$emit('toggle-menu')">All Psychics</router-link></li>
				<li><router-link to="/contacts" @click.native="$emit('toggle-menu')">Contact Submissions</router-link></li>
				<li><router-link to="/approvals" @click.native="$emit('toggle-menu')">Approvals</router-link></li>
				<li><router-link to="/statistics" @click.native="$emit('toggle-menu')">Statistics</router-link></li>
				<li><router-link to="/edit_profile" @click.native="$emit('toggle-menu')">Profile</router-link></li>
				<li><router-link to="/problem" @click.native="$emit('toggle-menu')">Report a Problem</router-link></li>
			</ul>
			<Logout @toggle-menu="$emit('toggle-menu')" />
		</aside>
	</div>
</template>

<script>
	import Logout from "../shared/Logout.vue"

	export default {
		components: {
			Logout
		},
		props: {
			menuOpen: Boolean
		}
	}
</script>